import { render, staticRenderFns } from "./NewsSlider.vue?vue&type=template&id=0b3a75c4&scoped=true&"
import script from "./NewsSlider.vue?vue&type=script&lang=js&"
export * from "./NewsSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewsSlider.vue?vue&type=style&index=0&id=0b3a75c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a75c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3a75c4')) {
      api.createRecord('0b3a75c4', component.options)
    } else {
      api.reload('0b3a75c4', component.options)
    }
    module.hot.accept("./NewsSlider.vue?vue&type=template&id=0b3a75c4&scoped=true&", function () {
      api.rerender('0b3a75c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewsSlider.vue"
export default component.exports